import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=1d023890&"
import script from "./forgetPassword.vue?vue&type=script&lang=ts&"
export * from "./forgetPassword.vue?vue&type=script&lang=ts&"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports